<template>
  <div>
    <ShopSteps :step="2" />
    <section class="mb-4 gry-bg">
      <div class="container">
        <div class="row cols-xs-space cols-sm-space cols-md-space">
          <div class="col-xxl-8 col-xl-10 mx-auto">
            <address-edit :selectable="true" ref="editAddress" class="mb-4" />
            <div class="row align-items-center">
              <div class="col-md-6 text-center text-md-left order-1 order-md-0">
                <router-link class="btn btn-link" to="/">
                  <i class="las la-arrow-left"></i>
                  {{ $t("返回商店") }}
                </router-link>
              </div>
              <div class="col-md-6 text-center text-md-right">
                <button class="btn btn-primary fw-600" @click="onClickContinue">
                  {{ $t("继续交货信息") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import ShopSteps from "@/components/ShopSteps.vue";
import AddressEdit from "@/components/AddressEdit.vue";

export default {
  components: {
    AddressEdit,
    ShopSteps
  },
  methods: {
    onClickContinue() {
      const item = this.$refs.editAddress.selectedAddress;
      if (item) {
        Cookies.set("checkout_addressId", item.id);
        this.jump("/user/checkout/delivery_info");
        // this.jump("/user/checkout/delivery_info?addressId=" + item.id);
      } else {
        this.$toast.fail(this.$t("选择一个地址"));
      }
    }
  },
  created() {
    if (!this.userCartItemCount) {
      this.jump("/user/cart");
    }
  }
};
</script>
